import { ValidationError } from "@common/types";

export class CriterionCreatorViewModel
{
    opened: boolean = false;

    parentId: number | null = null;
    parentName: string | null = null;
    name: string | null = null;
    description: string | null = null;
    nameError: string | null = null;

    show(parentId: number, parentName: string)
    {
        this.parentId = parentId;
        this.parentName = parentName;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.reset();
        this.parentId = null;
        this.parentName = null;
    }

    displayValidationErrors(errors: ValidationError[])
    {
        for (const error of errors)
        {
            if (error.ErrorCode === "Name.AlreadyExists")
            {
                this.nameError = error.Error;
            }
            else if (error.ErrorCode === "Name.Required")
            {
                this.nameError = error.Error;
            }
            else if (error.ErrorCode === "Name.MinLength")
            {
                this.nameError = error.Error;
            }
            else if (error.ErrorCode === "Name.MaxLength")
            {
                this.nameError = error.Error;
            }
        }
    }

    clearValidationErrors()
    {
        this.nameError = null;
    }

    reset()
    {
        this.name = null;
        this.description = null;
        this.clearValidationErrors();
    }
}